<div class="general-summary-title">
    <div class="title">
        {{ title }}
    </div>

    <div class="machines-container">
        <div class="machine-list" *ngIf="machineNameList.length <= 20">
            <ng-container *ngFor="let machine of machineNameList; index as i">
                {{ machine
                }}<span *ngIf="i < machineNameList.length - 1">, </span
                ><br *ngIf="(i + 1) % 10 === 0" />
            </ng-container>
        </div>
        <div class="machine-list" *ngIf="machineNameList.length > 20">
            <div *ngIf="!isViewMorePressed">
                <ng-container
                    *ngFor="let machine of shortMachineList; index as i"
                >
                    {{ machine
                    }}<span *ngIf="i < machineNameList.length - 1">, </span
                    ><br *ngIf="(i + 1) % 10 === 0" />
                </ng-container>
            </div>
            <div *ngIf="isViewMorePressed">
                <ng-container
                    *ngFor="let machine of machineNameList; index as i"
                >
                    {{ machine
                    }}<span *ngIf="i < machineNameList.length - 1">, </span
                    ><br *ngIf="(i + 1) % 10 === 0" />
                </ng-container>
            </div>
        </div>
        <div
            class="view-more"
            *ngIf="machineNameList.length > 20"
            (click)="viewMore()"
        >
            <div *ngIf="!isViewMorePressed">
                {{ "view_more" | lang }} <em class="fa fa-chevron-down"></em>
            </div>
            <div *ngIf="isViewMorePressed">
                {{ "view_less" | lang }} <em class="fa fa-chevron-up"></em>
            </div>
        </div>
    </div>
</div>

<div class="summary-status">
    <div #statusSummary></div>
</div>
